import { render, staticRenderFns } from "./ViewRoleComponent.vue?vue&type=template&id=166f49d8"
import script from "./ViewRoleComponent.vue?vue&type=script&lang=js"
export * from "./ViewRoleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports